import { controls, currencyToNumber, grouped } from "../../controls";
const trial_balance = {
  label: "trial_balance",
  starting: true,
  url: "trial_balance",
  pageLabel: "trial_balance",
  pageType: "history",
  filter: [
    ...controls.displayText({ tab: "filter", label: "gls" }),
    ...controls.oc({ tab: "filter", length: 5, c: "gls",placeHolder: "gl code", name: "gl_code", fastpath: "gls" }),
    ...controls.showData({ tab: "filter", displaytype: "capital", data: "gl_display" }),

    /**...grouped.grouping('basic'),
   ...grouped.separation('advance'),
   ...grouped.comparative('advance'),**/
 

  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "trial_balance",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },

    filterable:true,
    sortable: true,
    defaultsTo: 0,
    textReportProps: {
      '132': {
        filename: "trial_balance-$pageData.as_on_date$.oro",
        empty:true,//true
        format: {},
        header: "default",
        footer: "default"
      }
    },
    reportProps: { searchable: true, sortable: true },
  
     displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }//3
      },
      {
        Header: "Gl Number",
        accessor: "gl_code",
        
      },
      {
        Header: "Gl_Name",
        accessor: "gl_display",
      
    
      },
      {
        Header: "credit_amount",
        accessor: "credit",
        type: "currency"
        
      },
       {
        Header: "debit_amount",
        accessor: "debit",
        type: "currency"
        
      },
      
     // {
       // Header: "Transaction_type",
        //accessor: "transaction_type",
      
    
      //},


    ]
  }
};

export default trial_balance;